import type { NavGroup, RouteGroup } from './types';

import {
  AvailabilityRoute,
  CategoriesRoute,
  CouponRoutes,
  DiscountsRoute,
  ExternalCodesRoute,
  OptionsRoute,
  SeasonsRoute,
  StagesRoute,
  TagsRoute,
} from './configs/catalog';
import { ChangelogsRoutes } from './configs/changelogs';
import { GraphRoute, LookerStudioRoute, MonitoringRoute, TaskAIRoute } from './configs/charts';
import { DealersRoutes, ProvidersRoutes, TrenitaliaRoute } from './configs/dealers_and_providers';
import { ChallengesRoute, HomeRoute, MyPartnerRoute, TurnstilesRoute } from './configs/home';
import {
  MembershipsRoute,
  MembershipsStatsRoute,
  SogliePPURoute,
  TariffarioPPURoute,
  TransitsRoute,
} from './configs/memberships';
import {
  CarouselsRoute,
  DeparturesRoute,
  DistrictsRoute,
  GalleriesRoute,
  NotificationsRoute,
  PartnersRoute,
  PdfManagerRoute,
  PoliciesRoute,
  ReviewsRoute,
  ShippingRoute,
  SnowitcardsRoute,
  StageRoutesRoute,
} from './configs/misc';
import { CartsRoute, CassaRoute, OrdersRoute } from './configs/orders';
import { PricesRoute } from './configs/prices';
import { ProductRoute } from './configs/products';
import { CheckoutCodesRoute, HotelPromoRoutes, SkipassGroupsRoutes } from './configs/promos';
import {
  QuickSearchCardRoute,
  QuickSearchMembershipRoute,
  QuickSearchRoute,
} from './configs/search';
import {
  ApiKeysRoute,
  EmailRoute,
  ImportExportRoute,
  PDFRoute,
  QuickbooksRoute,
  SettingsRoute,
  WebshopRoute,
} from './configs/settings';
import { AdminToolsRoutes } from './configs/tools';
import {
  BrevoEmailRoute,
  PermissionsRoute,
  ProfilesRoute,
  RolesRoute,
  UserCreateRoute,
  UsersRoute,
} from './configs/users';
import { VenuesRoute } from './configs/venues';
import { ZonesRoute } from './configs/zones';

const ALL_NAVGROUPS: Record<RouteGroup, NavGroup> = {
  home: {
    id: 'home',
    routes: [HomeRoute, MyPartnerRoute, ChallengesRoute, TurnstilesRoute],
  },
  charts: {
    id: 'charts',
    routes: [GraphRoute, LookerStudioRoute, MonitoringRoute, TaskAIRoute],
  },
  search: {
    id: 'search',
    routes: [QuickSearchRoute, QuickSearchCardRoute, QuickSearchMembershipRoute],
  },
  users: {
    id: 'users',
    routes: [
      UsersRoute,
      ProfilesRoute,
      RolesRoute,
      PermissionsRoute,
      BrevoEmailRoute,
      UserCreateRoute,
    ],
  },
  orders: {
    id: 'orders',
    routes: [OrdersRoute, CassaRoute, CartsRoute],
  },
  cards: {
    id: 'cards',
    routes: [
      MembershipsRoute,
      MembershipsStatsRoute,
      SnowitcardsRoute,
      TransitsRoute,
      TariffarioPPURoute,
      SogliePPURoute,
    ],
  },
  catalog: {
    id: 'catalog',
    // label: 'routes.group.catalog',
    routes: [
      ProductRoute,
      OptionsRoute,
      CategoriesRoute,
      TagsRoute,
      DiscountsRoute,
      ExternalCodesRoute,
      CouponRoutes,
      SeasonsRoute,
      StagesRoute,
      AvailabilityRoute,
      PricesRoute,
    ],
  },
  providers: {
    id: 'providers',
    routes: [TrenitaliaRoute, ...ProvidersRoutes],
  },
  dealers: {
    id: 'dealers',
    routes: DealersRoutes,
  },
  lep: {
    id: 'lep',
    routes: [ChallengesRoute],
  },
  promos: {
    id: 'promos',
    routes: [HotelPromoRoutes, SkipassGroupsRoutes, CheckoutCodesRoute],
  },
  misc: {
    id: 'misc',
    routes: [
      NotificationsRoute,
      StageRoutesRoute,
      DeparturesRoute,
      CarouselsRoute,
      PartnersRoute,
      ReviewsRoute,
      DistrictsRoute,
      ZonesRoute,
      VenuesRoute,
      GalleriesRoute,
      PoliciesRoute,
      ShippingRoute,
      PdfManagerRoute,
    ],
  },
  settings: {
    id: 'settings',
    routes: [
      ImportExportRoute,
      EmailRoute,
      WebshopRoute,
      SettingsRoute,
      QuickbooksRoute,
      PDFRoute,
      ApiKeysRoute,
    ],
  },
  admin_tools: {
    id: 'admin_tools',
    routes: AdminToolsRoutes,
  },
  changelogs: {
    id: 'changelogs',
    routes: ChangelogsRoutes,
  },
};

export default Object.values(ALL_NAVGROUPS);
